module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_queso.aa47e2c2.jpg";